import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Bot, Settings2, Database, FlaskConical } from 'lucide-react';
import { cn } from '@/lib/cn';
import { ChatbotConfig } from '@/features/chatbot/ChatbotConfig';
import { KnowledgeBase } from '@/features/chatbot/KnowledgeBase';
import { ChatbotPlayground } from '@/features/chatbot/ChatbotPlayground';

export const Route = createFileRoute('/_app/chatbot')({
  component: ChatbotPage,
});

type Tab = 'config' | 'knowledge' | 'test';

const TABS: { id: Tab; label: string; icon: React.ReactNode }[] = [
  { id: 'config', label: 'Configuración', icon: <Settings2 className="size-4" /> },
  { id: 'knowledge', label: 'Base de conocimiento', icon: <Database className="size-4" /> },
  { id: 'test', label: 'Probar', icon: <FlaskConical className="size-4" /> },
];

function ChatbotPage() {
  const [tab, setTab] = useState<Tab>('config');

  return (
    <div className="mx-auto max-w-6xl space-y-6 p-6 md:p-8">
      <header>
        <h1 className="flex items-center gap-2 text-3xl font-bold tracking-tight">
          <Bot className="size-7 text-neutral-700" /> Chatbot
        </h1>
        <p className="text-sm text-neutral-500">
          Asistente del sitio con IA y base de conocimiento (RAG). Captura leads y los reenvía a tu CRM.
        </p>
      </header>

      <div className="flex gap-1 border-b border-neutral-200">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={cn(
              'flex items-center gap-2 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors',
              tab === t.id
                ? 'border-[#AD026A] text-[#AD026A]'
                : 'border-transparent text-neutral-500 hover:text-neutral-800',
            )}
          >
            {t.icon}{t.label}
          </button>
        ))}
      </div>

      {tab === 'config' && <ChatbotConfig />}
      {tab === 'knowledge' && <KnowledgeBase />}
      {tab === 'test' && <ChatbotPlayground />}
    </div>
  );
}
